import TrackSegmentedControl from '../TrackSegmentedControl';

// Same horizon labels as DayDetailDrawer, so the two drawers read identically.
const horizonLabel = (offset) => {
  if (offset == null) return '';
  if (offset === 0) return 'Intraday';
  if (offset === 1) return 'D+1';
  return `D+${offset}`;
};

const horizonLong = (offset) => {
  if (offset == null) return '';
  if (offset === 0) return 'Intraday';
  if (offset === 1) return 'Day-Ahead (D+1)';
  return `Extended (D+${offset})`;
};

const PaneControls = ({ track, onSelectTrack, horizonOffset, onSelectHorizon, availableHorizons }) => {
  const horizons = availableHorizons || [];
  return (
    <div className="flex flex-wrap items-center gap-4 px-5 sm:px-14 pt-5 pb-4">
      <TrackSegmentedControl selectedTrack={track} onSelectTrack={onSelectTrack} showMetric={false} />
      {/* Horizon switcher; with a single horizon it degrades to one
          non-interactive pill so users still see WHICH horizon is shown. */}
      {horizons.length > 0 && (
        <div className="flex min-w-0 max-w-full items-center gap-1.5 text-[11px]">
          <span className="flex-shrink-0 text-gray-500 dark:text-gray-400">Horizon:</span>
          {/* Scrolls horizontally when many horizons exceed the pane width
              (mobile); whitespace-nowrap keeps the pills on one line. */}
          <div className="inline-flex max-w-full overflow-x-auto whitespace-nowrap rounded-md border border-gray-200/70 dark:border-gray-600/70">
            {horizons.length === 1 ? (
              <span
                aria-disabled="true"
                className="px-2 py-0.5 bg-brand-500 text-white"
                title={horizonLong(horizons[0])}
              >
                {horizonLabel(horizons[0])}
              </span>
            ) : (
              horizons.map((h) => {
                const active = h === horizonOffset;
                return (
                  <button
                    key={h}
                    type="button"
                    onClick={() => onSelectHorizon(h)}
                    className={`px-2 py-0.5 transition-colors ${
                      active
                        ? 'bg-brand-500 text-white'
                        : 'bg-surface dark:bg-gray-870 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                    }`}
                    title={horizonLong(h)}
                  >
                    {horizonLabel(h)}
                  </button>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PaneControls;
